export default {
  default: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/layouts/default.vue").then(m => m.default || m),
  registration: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/layouts/registration.vue").then(m => m.default || m),
  results: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/layouts/results.vue").then(m => m.default || m),
  video: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/layouts/video.vue").then(m => m.default || m)
}